import { render, staticRenderFns } from "./inventory-other-items.vue?vue&type=template&id=57b9838c&"
import script from "./inventory-other-items.vue?vue&type=script&lang=js&"
export * from "./inventory-other-items.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports